.header {
  flex: 1;
}

.headerWrapper {
  display: flex;
  column-gap: var(--spacingMd);
}

.expandButtonColumn {
  display: flex;
  justify-content: center;
  padding: var(--spacingMd);
}

.hidden {
  // Make hidden body content not focusable with keyboard
  display: none;
}
